import { isProd } from 'utils/env.utils';

const REWARDS_PREFIX = isProd ? 'rewards' : 'acc-rewards';

export const SAUDI_REWARDS_FORGOT_PIN_URL = `https://${REWARDS_PREFIX}.visitsaudi.com/us/account`;

export const SAUDI_REWARDS_EDIT_ACCOUNT_URL = `https://${REWARDS_PREFIX}.visitsaudi.com/us/account`;

export const SAUDI_REWARDS_URL = `https://${REWARDS_PREFIX}.visitsaudi.com`;

export const SAUDI_REWARDS_BURN_CONVERSION_RATE = 0.02;
export const SAUDI_REWARDS_BURN_INCREMENTS = 50;
//We use talon one to set in "modifiers" the discount, this is the name of the modifier.
export const SAUDI_REWARDS_TALON_ONE_MODIFIER_NAME = 'SaudiRewardsBurnPoints';

export const brandConfig = {
  backgroundColor: '#3F263D',
  borderColor: 'rgba(202, 72, 192, 0.20)',
  mixBlendMode: 'screen',
  subLayer: '#78006E',
  gradient: {
    start: '#CA48C0',
    end: '#9C0890',
  },
};
